import {get_locations} from '~/api/zero-api';
import useDataLoader from '~/hooks/shared/useDataLoader';

export function useLocationsLoader(query) {
    return useDataLoader(() => get_locations(query));
}